import { Button, Form, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getExpenseById,
  updateExpenseById,
  getExpenses,
} from "store/slices/expensesSlice";
import { closeModal } from "store/slices/modalsSlice";
import { getSchools } from "store/slices/schoolsSlice";
import ExpenseForm from "./expense-form";

const EditExpenseModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { expense, loading } = useSelector((state) => state?.expenses);
  const { schools } = useSelector((state) => state?.schools);
  const open = isModalOpen && modalType === "edit_expense";

  const { userData } = useSelector((state) => state?.auth);
  useEffect(() => {
    if (open) {
      if (userData?._id) dispatch(getSchools(userData?._id));
      if (modalProps?.expenseId)
        dispatch(getExpenseById(modalProps?.expenseId));
    }
  }, [dispatch, open, userData?._id, modalProps?.expenseId]);

  useEffect(() => {
    if (expense && open) {
      form?.setFieldsValue({
        ...expense,
        creationDate: dayjs(expense?.creationDate),
        purchaseDate: dayjs(expense?.purchaseDate),
      });
    }
  }, [form, expense, open]);

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  const onSubmit = async (values) => {
    if (values?.purchaseDate) {
      values.purchaseDate = dayjs(values?.purchaseDate)?.format("YYYY-MM-DD");
    }
    return await dispatch(
      updateExpenseById({
        expenseId: modalProps?.expenseId,
        data: values,
      })
    )?.unwrap()?.then(() => {
        notification?.success({
          message: t("expenses.crud.form.success"),
        });
        onClose();
        // dispatch(getExpenses());
      })?.catch((error) => {
        notification?.error({
          message: t("expenses.crud.form.error.failed"),
        });
      });
  };

  return (
    <Modal
      title={<h4 style={{ textAlign: "center" }}>{t("expenses.crud.form")}</h4>}
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("expenses.crud.form.button.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="expense_form"
          disabled={loading}
        >
          {t("expenses.crud.form.button.save")}
        </Button>,
      ]}
      centered
      styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
    >
      <ExpenseForm
        expenseId={modalProps?.expenseId}
        schools={schools}
        onSubmit={onSubmit}
        form={form}
      />
    </Modal>
  );
};

export default EditExpenseModal;
